import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  const body: any = r.data;
  return (body?.data ?? body) as T;
}

export interface FeeTypeRow {
  id: string;
  name: string;
  description: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface OrgSchoolOption {
  id: string;
  name: string;
}

/** School-tier — real legacy `fees_types`, a plain label list (never referenced by a real FK from fee calculations). */
export const FeeTypesApi = {
  list: async (): Promise<FeeTypeRow[]> => unwrap(await api.get('/school/fee-types')),
  create: async (data: { name: string; description?: string }): Promise<FeeTypeRow> => unwrap(await api.post('/school/fee-types', data)),
  update: async (id: string, data: { name?: string; description?: string }): Promise<FeeTypeRow> =>
    unwrap(await api.patch(`/school/fee-types/${id}`, data)),
  remove: async (id: string): Promise<{ deleted: true; id: string }> => unwrap(await api.delete(`/school/fee-types/${id}`)),
};

/** Org tier — same CRUD, scoped to a picked school, plus an "apply to all schools" create option. */
export const OrgFeeTypesApi = {
  schools: async (): Promise<OrgSchoolOption[]> => unwrap(await api.get('/org/fee-types/schools')),
  list: async (schoolId: string): Promise<FeeTypeRow[]> => unwrap(await api.get('/org/fee-types', { params: { schoolId } })),
  create: async (data: { schoolId: string; name: string; description?: string }): Promise<FeeTypeRow[]> =>
    unwrap(await api.post('/org/fee-types', data)),
  update: async (id: string, schoolId: string, data: { name?: string; description?: string }): Promise<FeeTypeRow> =>
    unwrap(await api.patch(`/org/fee-types/${id}`, { ...data, schoolId })),
  remove: async (id: string, schoolId: string): Promise<{ deleted: true; id: string }> =>
    unwrap(await api.delete(`/org/fee-types/${id}`, { params: { schoolId } })),
};
